export default __webpack_public_path__ + "static/5_19-b5ccac7237a945da3214420d3d032e0a.png";